<!--
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2021-07-13 09:26:22
 * @LastEditors: xiawenlong
 * @LastEditTime: 2026-02-09 17:06:16
-->
<template>
  <div class="map-container">
    <div class="map-bg">
      <div
        v-for="(item, index) in areaList"
        :key="index"
        :class="[item.districtCode, 'map-item', { active: activeIndex == index }]"
        @click="handleClick(item, index)"
      >
        <!-- <div class="map-card">
          <div class="title">{{ item.districtName }}</div>
          <div class="price">
            销售额：<span>{{ item.amount }}</span> 元
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import { areaSaleTotal } from '@/api/dashboard'
import to from 'await-to'
export default {
  data() {
    return {
      activeIndex: 0,
      areaList: 0,
      timer: null,
      changeTime: 60000,
    }
  },
  async mounted() {
    await this.initData()
    this.timer = setInterval(() => {
      this.setChange()
    }, this.changeTime)
    setInterval(() => {
      this.initData()
    }, process.env.VUE_APP_LTIME)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    async initData() {
      const [res, err] = await to(areaSaleTotal())
      if (err) return
      this.areaList = res.data
      this.$emit('change', this.areaList[this.activeIndex], this.activeIndex)
    },
    setChange() {
      if (this.activeIndex < 16) this.activeIndex++
      else this.activeIndex = 0
      this.$emit('change', this.areaList[this.activeIndex], this.activeIndex)
    },
    handleClick(item, index) {
      this.activeIndex = index
      this.$emit('change', item, this.activeIndex)
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.setChange()
      }, this.changeTime)
    },
  },
}
</script>
<style lang="scss" scoped>
.map-container {
  position: relative;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  padding-top: 47px;
  .map-bg {
    position: relative;
    width: 788px;
    height: 972px;
    background: url('~@/img/datav/map/map.png');
    font-weight: normal;
    font-size: 25px;
    color: #ecf8ff;
    text-shadow: 0px 2px 4px rgba(0, 13, 47, 0.61);
    .map-item {
      box-sizing: border-box;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      position: absolute;
      .map-card {
        transition: all 0.5s;
        display: none;
        opacity: 0;
        position: absolute;
        left: -40%;
        top: -100px;
        z-index: 999;
        min-width: 437px;
        .title {
          box-sizing: border-box;
          height: 82px;
          box-shadow: inset 0px 6px 27px 1px #1f94c3;
          border-radius: 2px 2px 2px 2px;
          background: rgba(20, 94, 115, 0.64);
          border: 2px solid #707070;
          font-weight: bold;
          font-size: 36px;
          color: #ffffff;
          line-height: 82px;
          text-align: center;
        }
        .price {
          white-space: nowrap;
          display: inline-block;
          padding: 0 28px;
          height: 84px;
          box-shadow: inset 1px 1px 11px 1px #2f5891;
          border-radius: 3px 3px 3px 3px;
          background: rgba(0, 0, 0, 0.6);
          font-weight: 500;
          font-size: 42px;
          color: #ffffff;
          line-height: 84px;
          text-align: center;
          span {
            color: #ff8800;
          }
        }
      }
      &:hover,
      &.active {
        z-index: 999;
        filter: drop-shadow(0 0 20px rgba(0, 212, 255, 0.8));
        &::after {
          opacity: 1;
        }
        .map-card {
          z-index: 999;
          opacity: 1;
          display: block;
        }
      }
      &::after {
        transition: all 0.5s;
        opacity: 0;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        content: '';
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }
    }
    .wd {
      left: 106px;
      top: -10px;
      width: 236px;
      height: 340px;
      background-image: url('~@/img/datav/map/wd.png');
      padding-top: 175px;
      padding-left: 59px;
      &::after {
        background-image: url('~@/img/datav/map/wd_active.png');
      }
    }
    .hd {
      left: 196px;
      top: 136px;
      width: 207px;
      height: 372px;
      background-image: url('~@/img/datav/map/hd.png');
      padding-top: 175px;
      padding-left: 59px;
      &::after {
        background-image: url('~@/img/datav/map/hd_active.png');
      }
    }
    .yd {
      left: -2px;
      top: 257px;
      width: 237px;
      height: 305px;
      background-image: url('~@/img/datav/map/yd.png');
      &::after {
        background-image: url('~@/img/datav/map/yd_active.png');
      }
    }
    .gm {
      left: 114px;
      top: 413px;
      width: 255px;
      height: 199px;
      background-image: url('~@/img/datav/map/gm.png');
      &::after {
        background-image: url('~@/img/datav/map/gm_active.png');
      }
    }
    .mp {
      left: 8px;
      top: 548px;
      width: 115px;
      height: 194px;
      background-image: url('~@/img/datav/map/mp.png');
      &::after {
        background-image: url('~@/img/datav/map/mp_active.png');
      }
    }
    .cl {
      left: 44px;
      top: 581px;
      width: 202px;
      height: 376px;
      background-image: url('~@/img/datav/map/cl.png');
      &::after {
        background-image: url('~@/img/datav/map/cl_active.png');
      }
    }
    .cj {
      left: 197px;
      top: 557px;
      width: 231px;
      height: 160px;
      background-image: url('~@/img/datav/map/cj.png');
      &::after {
        background-image: url('~@/img/datav/map/cj_active.png');
      }
    }
    .ld {
      left: 215px;
      top: 686px;
      width: 247px;
      height: 116px;
      background-image: url('~@/img/datav/map/ld.png');
      &::after {
        background-image: url('~@/img/datav/map/ld_active.png');
      }
    }
    .cx {
      left: 169px;
      top: 761px;
      width: 315px;
      height: 156px;
      background-image: url('~@/img/datav/map/cx.png');
      &::after {
        background-image: url('~@/img/datav/map/cx_active.png');
      }
    }
    .ch {
      left: 321px;
      top: 276px;
      width: 272px;
      height: 324px;
      background-image: url('~@/img/datav/map/ch.png');
      &::after {
        background-image: url('~@/img/datav/map/ch_active.png');
      }
    }
    .ys {
      left: 370px;
      top: 595px;
      width: 76px;
      height: 84px;
      background-image: url('~@/img/datav/map/ys.png');
      &::after {
        background-image: url('~@/img/datav/map/ys_active.png');
      }
    }
    .sl {
      left: 398px;
      top: 445px;
      width: 182px;
      height: 305px;
      background-image: url('~@/img/datav/map/sl.png');
      &::after {
        background-image: url('~@/img/datav/map/sl_active.png');
      }
    }
    .lid {
      left: 442px;
      top: 671px;
      width: 207px;
      height: 165px;
      background-image: url('~@/img/datav/map/lid.png');
      &::after {
        background-image: url('~@/img/datav/map/lid_active.png');
      }
    }
    .tp {
      left: 430px;
      top: 818px;
      width: 168px;
      height: 144px;
      background-image: url('~@/img/datav/map/tp.png');
      &::after {
        background-image: url('~@/img/datav/map/tp_active.png');
      }
    }
    .gs {
      left: 493px;
      top: 509px;
      width: 208px;
      height: 220px;
      background-image: url('~@/img/datav/map/gs.png');
      &::after {
        background-image: url('~@/img/datav/map/gs_active.png');
      }
    }
    .wsg {
      left: 564px;
      top: 377px;
      width: 222px;
      height: 354px;
      background-image: url('~@/img/datav/map/wsg.png');
      &::after {
        background-image: url('~@/img/datav/map/wsg_active.png');
      }
    }
    .yz {
      left: 572px;
      top: 708px;
      width: 195px;
      height: 204px;
      background-image: url('~@/img/datav/map/yz.png');
      &::after {
        background-image: url('~@/img/datav/map/yz_active.png');
      }
    }
    .kfq {
      left: 574px;
      top: 632px;
      width: 187px;
      height: 57px;
      background-image: url('~@/img/datav/map/kfq.png');
      &::after {
        background-image: url('~@/img/datav/map/kfq_active.png');
      }
    }
  }
}
</style>
